import { getExpertise } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import {
  ExpertReportType,
  IVehiculeExpertise,
  IVictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { get, isEmpty, isUndefined } from 'lodash';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
export const getDecidedReportByField = (
  expertise: IVictimExpertise | IVehiculeExpertise,
) => {
  const victimReport = { ...expertise } as IVictimExpertise;
  const vehiculeReport = { ...expertise } as IVehiculeExpertise;

  if (!!victimReport.victimExpertise) {
    return victimReport.victimExpertise;
  }

  if (!!vehiculeReport.vehiculeExpertise) {
    return vehiculeReport.vehiculeExpertise;
  }
  return {};
};
export const showDecision = (
  expertise: IVictimExpertise | IVehiculeExpertise,
) => {
  return (
    !isEmpty(get(getDecidedReportByField(expertise), 'status')) &&
    get(getDecidedReportByField(expertise), 'status') !==
      PROCEDURE_STATUSES.PENDING
  );
};
export const displayDecisionExpertise = (
  expertReport: any,
  expertReportState: ExpertReportType,
) => {
  const { EXPERT_TYPE } = getExpertise(expertReport);
  const showDecisionOnRejection =
    get(expertReport[EXPERT_TYPE], 'status') === STATUS_REJECTED &&
    featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER);
  return featureService.hasFeature(FEATURES.EVOLUTION_P1)
    ? get(expertReport[EXPERT_TYPE], 'status') === STATUS_PENDING ||
        (get(expertReport[EXPERT_TYPE], 'status') === '' &&
          get(expertReportState, 'status') === STATUS_PENDING) ||
        showDecisionOnRejection
    : (get(expertReport[EXPERT_TYPE], 'status') === STATUS_PENDING ||
        (get(expertReport[EXPERT_TYPE], 'status') === '' &&
          get(expertReportState, 'status') === STATUS_PENDING) ||
        showDecisionOnRejection) &&
        !get(expertReport[EXPERT_TYPE], 'isOld') &&
        !(
          get(expertReport[EXPERT_TYPE], 'isNew') &&
          !isUndefined(get(expertReport[EXPERT_TYPE], 'isNew'))
        );
};
